import { LiveKItJoinHandlerInterface } from "@share/live-kit/interfaces/LiveKItJoinHandlerInterface";
import { LiveKitClient } from "@share/live-kit/live-kit-classes/LiveKitClient";
import { WebConferenceService } from "@share/web-conferences/data/WebConferenceService";
import { WebConferenceError } from "@api/models/web-conferences/WebConferenceError";
import { sleep } from "@share/web-conferences/helpers/SleepHelper";
import { showAccessErrorModal, showConnectionErrorModal } from "@share/web-conferences/helpers/ErrorModal";
import { UserRoleType } from "@share/web-conferences/enums/UserRoleType";
import { LiveKitCredentials } from "@api/models/web-conferences/LiveKitCredentials";
import { LiveKitParticipantsEventsHandler } from "@share/live-kit/live-kit-classes/LiveKitParticipantsEventsHandler";
import { loggerInstance } from "@share/live-kit/logger";

const attemptsToReconnect = 3;

export class LiveKitJoinHandler implements LiveKItJoinHandlerInterface {
    cantJoin: boolean;

    constructor(
        public readonly webConferenceService: WebConferenceService,
        public readonly client: LiveKitClient
    ) {
    }

    get webConferenceData() {
        return this.webConferenceService.webConferenceData;
    }

    async fetchWebConferenceData() {
        await this.webConferenceService.join();
    }


    async join(): Promise<void> {
        let canJoin = false;
        let error: WebConferenceError | null  = null;

        for (let i = 1; i <= attemptsToReconnect; i++) {
            loggerInstance.log('before join to appercode');
            const result = await this.webConferenceService.join();
            loggerInstance.log('joined to appercode' + JSON.stringify(result));
            if(result instanceof WebConferenceError) {
                error = result;
                break;
            }

            if (this.webConferenceService.isWebConferenceDataNotEmpty()) {
                loggerInstance.log('before joining to livekit');
                canJoin = await this.client.join(
                    this.webConferenceService.webConferenceData?.userRole as UserRoleType,
                    this.webConferenceService.liveKitCredentials as LiveKitCredentials
                );
                // if (this.shareClient.joined) {
                //     await this.joinScreenShareClient();
                // }
                break;
            }
            else {
                await sleep(5000);
            }
        }
        this.cantJoin = !canJoin;

        if(error) {
            showAccessErrorModal(error.code);
        }
        else if(this.cantJoin && !this.webConferenceService.isWebConferenceDataNotEmpty()) {
            showConnectionErrorModal();
        }
    }

}
